<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Aktualności</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Aktualności</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Filtry</h5>
            <span class="ibox-toggle" @click="isFiltersOpen = !isFiltersOpen">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="formatRange"
                    range
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Aktualności</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <router-link v-if="canAddNews" to="/news/create">
              <button class="btn btn-sm btn-primary">Dodaj</button>
            </router-link>
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @expand-row="editNews"
                  alternating
                  multi-sort
                  show-index
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                  <template #expand>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis aktualności [pl]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isPlOpen = !isPlOpen"
                            >
                              <i :class="chevronPlClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isPlOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="newsObj.title_pl"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_pl[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Treść
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <Editor
                                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                                    v-model="newsObj.content_pl"
                                    :init="{
                                      toolbar_mode: 'sliding',
                                      plugins:
                                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                                      toolbar:
                                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                                    }"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_pl"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_pl[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis aktualności [en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isEnOpen = !isEnOpen"
                            >
                              <i :class="chevronEnClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isEnOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="newsObj.title_en"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_en"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_en[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Treść
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <Editor
                                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                                    v-model="newsObj.content_en"
                                    :init="{
                                      toolbar_mode: 'sliding',
                                      plugins:
                                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                                      toolbar:
                                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                                    }"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.content_en"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.content_en[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis aktualności [de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeOpen = !isDeOpen"
                            >
                              <i :class="chevronDeClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isDeOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="newsObj.title_de"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_de[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Treść
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <Editor
                                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                                    v-model="newsObj.content_de"
                                    :init="{
                                      toolbar_mode: 'sliding',
                                      plugins:
                                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                                      toolbar:
                                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                                    }"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.content_de"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.content_de[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis aktualności [de_de]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeDeOpen = !isDeDeOpen"
                            >
                              <i :class="chevronDeDeClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isDeDeOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="newsObj.title_cpde"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Nazwa"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_cpde"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_cpde[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Treść
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <Editor
                                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                                    v-model="newsObj.content_cpde"
                                    :init="{
                                      toolbar_mode: 'sliding',
                                      plugins:
                                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                                      toolbar:
                                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                                    }"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.content_cpde"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.content_cpde[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Opis aktualności [de_en]</h5>
                            <span
                              class="ibox-toggle"
                              @click="isDeEnOpen = !isDeEnOpen"
                            >
                              <i :class="chevronDeEnClass"></i>
                            </span>
                          </div>

                          <div class="form-horizontal" v-show="isDeEnOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Tytuł
                                </label>
                                <div class="col-sm-10">
                                  <input
                                    v-model="newsObj.title_cpen"
                                    name="name"
                                    type="text"
                                    class="form-control inputClass"
                                    placeholder="Tytuł"
                                    required="required"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.title_cpen"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.title_cpen[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Treść
                                </label>
                                <div class="col-sm-10 QuillEditor-box">
                                  <Editor
                                    api-key="9csaeb3mljywong9mh5nhj1vdunzpft9enx56len33n2ly2f"
                                    v-model="newsObj.content_cpen"
                                    :init="{
                                      toolbar_mode: 'sliding',
                                      plugins:
                                        'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks code wordcount',
                                      toolbar:
                                        'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
                                    }"
                                  />
                                  <div
                                    v-if="errorsAdminData?.data?.content_cpen"
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{ errorsAdminData.data.content_cpen[0] }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="ibox float-e-margins">
                          <div class="ibox-title">
                            <h5>Konfiguracja aktualności</h5>
                            <span
                              class="ibox-toggle"
                              @click="isConfigOpen = !isConfigOpen"
                            >
                              <i :class="chevronConfigClass"></i>
                            </span>
                          </div>
                          <div class="form-horizontal" v-show="isConfigOpen">
                            <div class="ibox-content">
                              <div class="form-group">
                                <label class="control-label col-sm-2">
                                  Data publikacji
                                </label>
                                <div class="col-sm-10">
                                  <VueDatePicker
                                    :format="format"
                                    v-model="publication_date"
                                  />
                                  <div
                                    v-if="
                                      errorsAdminData?.data?.publication_date
                                    "
                                    class="has-error"
                                  >
                                    <span class="help-block">
                                      {{
                                        errorsAdminData.data.publication_date[0]
                                      }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="form-group">
                                <div class="col-sm-4 col-sm-offset-2">
                                  <button class="btn btn-white" @click="cancel">
                                    Anuluj
                                  </button>
                                  <button
                                    v-if="canChangeNews"
                                    @click="saveEdit"
                                    class="btn btn-primary"
                                  >
                                    Zapisz
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template #item-title="item">
                    {{ item.title_pl }}
                  </template>
                  <template #item-content="item">
                    <span v-html="item.content_pl"></span>
                  </template>
                  <template #item-actions="item">
                    <button
                      v-if="canDeleteNews"
                      @click.stop="
                        showModal = item.pk;
                        deleteName = item.title_pl;
                      "
                      class="btn btn-danger btn-xs"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal"
    :title="'Potwierdzenie usunięcia'"
    :content="'Czy na pewno chcesz usunąć <b>' + deleteName + '</b> ?'"
    @callbackOk="deleteNews(showModal)"
    @callbackClose="showModal = false"
  />
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Modal from "../caffeprint/Modal.vue";
import Editor from "@tinymce/tinymce-vue";
import { hasPermission } from "../../permissions";
import { newsPermissionsConst } from "../../constants/newsConstants";

export default {
  name: "NewsList",
  mixins: [],
  components: {
    Modal,
    Editor,
  },
  props: {},

  setup() {
    const store = useStore();
    const canAddNews = computed(() => hasPermission(newsPermissionsConst.add));
    const canChangeNews = computed(() =>
      hasPermission(newsPermissionsConst.update)
    );
    const canDeleteNews = computed(() =>
      hasPermission(newsPermissionsConst.delete)
    );
    const deleteNewsData = computed(() => store.getters.getDeleteNewsData);
    const newsData = computed(() => store.getters.getNewsData);
    const updateNewsData = computed(() => store.getters.getUpdateNewsData);
    const newsListData = computed(() => store.getters.getNewsListData);
    const newsObj = ref({
      title_pl: "",
      content_pl: "",
      title_en: "",
      content_en: "",
      title_de: "",
      content_de: "",
      title_cpde: "",
      content_cpde: "",
      title_cpen: "",
      content_cpen: "",
      publication_date: "",
    });
    let headers = [
      { text: "Id", value: "pk", sortable: true, search: true },
      { text: "Tytuł", value: "title", search: true, sortable: true },
      { text: "Treść", value: "content", search: true, sortable: true },
      { text: "Data publikacji", value: "publication_date", sortable: true },
      { text: "Data dodania", value: "date_added", sortable: true },
      { text: "Data modyfikacji", value: "date_modified", sortable: true },
      {
        text: "Zmodyfikowano przez",
        value: "last_modified_by",
        sortable: true,
      },
      {
        text: "Utworzono przez",
        value: "created_by",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const showModal = ref(false);
    const deleteName = ref("");
    const publication_date = ref();
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const defRowsPerPage = ref(25);
    const filterRangeDate = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: defRowsPerPage.value,
    });

    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);
    const isPlOpen = ref(true);
    const isEnOpen = ref(true);
    const isDeOpen = ref(true);
    const isDeDeOpen = ref(true);
    const isDeEnOpen = ref(true);
    const isConfigOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronPlClass = computed(() =>
      isPlOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronEnClass = computed(() =>
      isEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeClass = computed(() =>
      isDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeDeClass = computed(() =>
      isDeDeOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronDeEnClass = computed(() =>
      isDeEnOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronConfigClass = computed(() =>
      isConfigOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const getNewsList = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getNewsList", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
      });
    };

    const format = (date) => {
      let day, month, year, hours, minutes, seconds;
      day = date.getDate();
      month = ("0" + (date.getMonth() + 1)).slice(-2);
      year = date.getFullYear();
      minutes = ("0" + date.getMinutes()).slice(-2);
      seconds = ("0" + date.getSeconds()).slice(-2);
      hours = date.getHours();

      return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
    };

    const formatRange = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const deleteNews = (pk) => {
      showModal.value = false;
      if (!canDeleteNews.value) {
        return;
      }
      store.dispatch("deleteNews", {
        pk: pk,
      });
    };
    const saveEdit = () => {
      if (!canChangeNews.value) {
        return;
      }
      newsObj.value.publication_date = format(publication_date.value);
      store.dispatch("updateNews", newsObj.value);
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    const editNews = (globalIndex) => {
      cancel();
      const localIndex =
        globalIndex - (serverOptions.value.page - 1) * defRowsPerPage.value;
      store.dispatch("getNews", { pk: items.value[localIndex].pk });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getNewsList();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      filterRangeDate.value = [];
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getNewsList();
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const parseCustomDate = (dateStr) => {
      const [date, time] = dateStr.split(" ");
      const [day, month, year] = date.split(".");
      const [hour, minute, second] = time.split(":");
      const formattedDate = `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      return new Date(formattedDate);
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("newsSearchValue") !== null) {
        searchValue.value = localStorage.getItem("newsSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (
        localStorage.getItem("newsRangeDate") !== null &&
        localStorage.getItem("newsRangeDate") !== undefined &&
        localStorage.getItem("newsRangeDate") !== "undefined"
      ) {
        filterRangeDate.value = localStorage.getItem("newsRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }
      getNewsList();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "newsSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "newsRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getNewsList();
      }
    );

    watch(
      () => newsListData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => newsData.value,
      function (newValue) {
        newsObj.value = newValue.data;
        publication_date.value = parseCustomDate(
          newValue.data.publication_date
        );
      }
    );

    watch(
      () => deleteNewsData.value,
      function (newValue) {
        if (newValue.status === 204) {
          store.dispatch("showToaster", {
            type: "success",
            content: "News został usunięty",
          });
        }
        getNewsList();
      }
    );

    watch(
      () => updateNewsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getNewsList();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getNewsList();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      serverOptions,
      showModal,
      deleteNews,
      deleteName,
      newsObj,
      cancel,
      editNews,
      saveEdit,
      publication_date,
      format,
      formatRange,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      selectPage,
      setRowsPerPage,
      filterRangeDate,
      isFiltersOpen,
      isMainOpen,
      isPlOpen,
      isEnOpen,
      isDeOpen,
      isDeDeOpen,
      isDeEnOpen,
      isConfigOpen,
      chevronFiltersClass,
      chevronMainClass,
      chevronPlClass,
      chevronEnClass,
      chevronDeClass,
      chevronDeDeClass,
      chevronDeEnClass,
      chevronConfigClass,
      canAddNews,
      canChangeNews,
      canDeleteNews,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
